import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './CreativeChartHeader.css';
import sharedCss from './sharedTabStyles.css';
import { Dropdown } from '../../../components/widgets';
import ToggleTabGroup from '../../../components/atoms/ToggleTabGroup';
import TopXChartDataFilter from '../../../components/partials/TopXChartDataFilter';
import { BreakdownType } from './consts';

const CreativeChartHeader = ({
    title,
    dropdowns = [],
    breakdownsOptions = [],
    selectedBreakdown,
    onBreakdownChange,
    breakdownsInputType = BreakdownType.TABS,
    breakdownsDropdownLabel,
    onTopXChanged,
    showTopX = false,
    selectedTopX = 5,
    rowDataLength = 0,
    isTopXDisabled = false,
}) => {
    const handleTabToggle = optionValue => {
        const clickedTab = breakdownsOptions.find(tab => tab.value === optionValue);
        if (clickedTab) onBreakdownChange(clickedTab);
    };

    return (
        <div className={css.header}>
            <span className={sharedCss.sectionTitle}>
                <Translate id={title} />
            </span>
            <div className={css.controls}>
                {breakdownsInputType === BreakdownType.TABS && (
                    <ToggleTabGroup
                        options={breakdownsOptions.map(tab => ({
                            option: tab.value,
                            label: tab.label,
                        }))}
                        selectedOption={selectedBreakdown?.value}
                        onToggle={handleTabToggle}
                    />
                )}
                {breakdownsInputType === BreakdownType.DROPDOWN && (
                    <Dropdown
                        selected={selectedBreakdown}
                        onSelection={onBreakdownChange}
                        items={breakdownsOptions}
                        containerClass={css.dropdown}
                        selectedContainer={css.selectedDropdown}
                        bodyClassName={css.dropdownBody}
                        label={breakdownsDropdownLabel}
                    />
                )}
                {dropdowns.map((dropdown, index) => (
                    <Dropdown
                        key={dropdown.label || `dropdown-${index}`}
                        selected={dropdown.selected}
                        onSelection={dropdown.onChanged}
                        items={dropdown.options}
                        containerClass={css.dropdown}
                        selectedContainer={css.selectedDropdown}
                        bodyClassName={css.dropdownBody}
                        label={dropdown.label}
                    />
                ))}
                {showTopX && (
                    <TopXChartDataFilter
                        topXCount={selectedTopX}
                        rowDataLength={rowDataLength}
                        onChange={onTopXChanged}
                        withShowAll
                        className={css.topXWrapper}
                        labelClassName={css.topXLabel}
                        dropdownClassName={css.topXDropdown}
                        disabled={isTopXDisabled}
                    />
                )}
            </div>
        </div>
    );
};

CreativeChartHeader.propTypes = {
    title: PropTypes.string,
    dropdowns: PropTypes.arrayOf(
        PropTypes.shape({
            options: PropTypes.arrayOf(
                PropTypes.shape({
                    value: PropTypes.string,
                    label: PropTypes.string,
                })
            ),
            selected: PropTypes.shape({
                value: PropTypes.string,
                label: PropTypes.string,
            }),
            onChanged: PropTypes.func,
            label: PropTypes.string,
        })
    ),
    breakdownsOptions: PropTypes.array,
    selectedBreakdown: PropTypes.object,
    onBreakdownChange: PropTypes.func,
    breakdownsInputType: PropTypes.oneOf([BreakdownType.TABS, BreakdownType.DROPDOWN]),
    breakdownsDropdownLabel: PropTypes.string,
    showTopX: PropTypes.bool,
    selectedTopX: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onTopXChanged: PropTypes.func,
    rowDataLength: PropTypes.number,
    isTopXDisabled: PropTypes.bool,
};

export default CreativeChartHeader;
